import {AfterViewInit, Component, OnInit} from '@angular/core';
import {EventsManager} from "../../events/events.manager";
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {phoneValidator, ValidateEmail} from "../validators/form-validator";
import {ContactUsRequestModel} from "../../models/contact-us.request.model";
import {PlansService} from "../../services/plans.service";
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { PhonePipe } from '../../pipes/phone.pipe';
import { CardItemComponent } from '../common/card-item/card-item.component';
import { RouterLink } from '@angular/router';
import { NgIf, NgFor } from '@angular/common';
import { HeroComponent } from '../hero/hero.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
    imports: [HeroComponent, NgIf, NgFor, RouterLink, CardItemComponent, FormsModule, ReactiveFormsModule, PhonePipe]
})
export class HomeComponent implements OnInit, AfterViewInit {
details:any = {};
showDetails:boolean = false;
showContactSuccess:boolean = false;
showContactError:boolean = false;
  constructor(public em:EventsManager,private plansService:PlansService, private googleAnalyticsService: GoogleAnalyticsService) { }
  contactUs: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required,Validators.minLength(3)]),
    email: new FormControl('', [Validators.required,ValidateEmail]),
    message: new FormControl('', [Validators.required,Validators.minLength(3)]),
    planName: new FormControl(this.em.planName),
    planEmail: new FormControl(this.em.planEmail),
  })
  info:any = {};
  ngOnInit(): void {
    this.em.contactInfoUpdated.subscribe(
      () => {
        this.info = this.em.contactInfo;

      }
    )
    this.em.homePageDetailUpdated.subscribe(
      (details:any) => {
        this.details = this.em.homePageDetails;
        if(this.em.homePageDetails !== null){
          this.showDetails = true;
        }

      })
  }

  ngAfterViewInit(){
    window.scroll(0,-window.scrollY);
  }
  sendForm(){
    const request:ContactUsRequestModel = {name:this.contactUs.get('name')?.value,email:this.contactUs.get('email')?.value,message:this.contactUs.get('message')?.value,planName:this.contactUs.get('planName')?.value,planEmail:this.contactUs.get('planEmail')?.value};
    this.plansService.sendContactUs(request).subscribe(
      () => {
        this.showContactSuccess = true;
        this.googleAnalyticsService.sendKeyEvent('contact_us_submit', {
          timestamp: new Date().toISOString()
        });
      },
      () => {
        this.showContactError = true;
      }
    )
  }

  findDentist() {
    this.googleAnalyticsService.sendKeyEvent('find_dentist', {
      timestamp: new Date().toISOString()
    });
  }
}
